import React, { useMemo } from 'react'

import {
  Container,
  OptionHolder,
  Option,
  OptionIcon
} from './CheckboxForm.styles'
import { colors } from '../../themes'

interface CheckboxFormProps {
  options: Array<string>
  selected: Array<string>
  onSelect: (items: Array<string>) => any
  selectionBackground?: string
}

export default function CheckboxForm({
  options,
  selected,
  onSelect,
  selectionBackground
}: CheckboxFormProps) {
  const selectedSet = useMemo(() => new Set(selected), [selected])

  return (
    <Container>
      {options.map((option, index) => {
        const prevSelected = selectedSet.has(options[index - 1])
        const curSelected = selectedSet.has(option)

        const classes = []
        if (curSelected) {
          classes.push('selected')
        }
        if (index > 0 && !curSelected && !prevSelected) {
          classes.push('upperBorder')
        }

        return (
          <OptionHolder
            key={index}
            className={classes.join(' ')}
            selectionBackground={
              selectionBackground || colors.radioForm.defaultSelectedBackground
            }
            onClick={() => {
              if (!selected) selected = []
              if (curSelected) {
                onSelect(selected.filter(o => o !== option))
              } else {
                onSelect(selected.concat(option))
              }
            }}
          >
            <Option
              className={classes.join(' ')}
              selectionBackground={
                selectionBackground ||
                colors.radioForm.defaultSelectedBackground
              }
            >
              <OptionIcon selected={curSelected} />
              {option}
            </Option>
          </OptionHolder>
        )
      })}
    </Container>
  )
}
